var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 49,
    viewBox: "0 0 93 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 0H0V49H93V0Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6009 27.4998C47.7809 27.3098 47.9609 27.1298 48.1409 26.9398C48.3009 26.7798 48.4509 26.6198 48.6109 26.4698C49.3109 25.7898 50.2209 25.7998 50.9109 26.4898C51.5109 27.0998 52.1209 27.6998 52.7209 28.3098C53.0509 28.6498 53.2409 29.0498 53.2209 29.5298C53.2009 29.9498 53.0309 30.2998 52.7409 30.5998C52.5509 30.7998 52.3509 30.9798 52.1609 31.1798C52.0109 31.3398 51.8609 31.4898 51.7109 31.6598C51.1609 32.2598 50.4709 32.5298 49.6709 32.4998C48.7909 32.4698 47.9609 32.2198 47.1509 31.8598C44.7309 30.7998 42.7409 29.2098 41.1209 27.1298C40.1709 25.9198 39.3909 24.6098 38.8909 23.1398C38.6609 22.4698 38.5209 21.7898 38.5509 21.0698C38.5809 20.4398 38.7909 19.8898 39.2309 19.4298C39.6209 19.0198 40.0109 18.6198 40.4209 18.2298C41.0909 17.5798 42.0109 17.5698 42.6809 18.2198C43.3209 18.8398 43.9409 19.4698 44.5609 20.0998C45.0009 20.5498 45.1709 21.0798 44.9709 21.6998C44.8909 21.9598 44.7309 22.1798 44.5409 22.3798C44.2209 22.6998 43.9009 23.0198 43.5809 23.3398C43.5209 23.3898 43.5209 23.4298 43.5509 23.4998C43.8509 24.1098 44.2609 24.6498 44.7109 25.1598C45.3709 25.9098 46.1009 26.5798 46.9309 27.1198C47.1509 27.2698 47.3709 27.3698 47.6009 27.4998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2812 19.3896C47.2812 19.3896 51.2613 19.5696 51.6213 23.7696",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4219 16.5C47.4219 16.5 53.6619 17.22 54.4419 23.63",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.01738072.svg";
export { ForwardRef as ReactComponent };